<template>
  <div>
    <b-list-group class="mb-2">
      <b-list-group-item variant="primary" class="font-weight-bold"
        >Members Signed In</b-list-group-item
      >
    </b-list-group>
    <b-button
      block
      variant="primary"
      v-for="(item, key) in peopleAttendingToday"
      :key="key"
      class="font-weight-bold"
      @click="signOut(item)"
      >{{ item.firstName }} {{ item.lastName }} Sign out</b-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["urlPrefix", "peopleAttendingToday"]),
  },

  mounted() {
    this.getAttendaceData();
  },

  methods: {
    getAttendaceData() {
      const payload = {
        url: this.urlPrefix + "api/attendance/?today=true",
        mutationName: "addToPeopleAttending",
      };
      this.$store.dispatch("genericGetApiCall", payload);
    },

    signOut(signInSession) {
      // so this is a patch to the existing record based upon the id
      // we need to update the dateOut (which will be today and time out which will be now ... well now when the buttons pressed not when your reading this!)
      const id = signInSession.id;
      const isoDateTime = new Date().toISOString();
      const isoDate = isoDateTime.slice(0, 10);
      const isoTime = isoDateTime.slice(11, 19);
      const mutationName = "removeFromPeopleAttending";
      const url = this.urlPrefix + "api/attendance/" + id + "/";
      const data = {
        dateOut: isoDate,
        timeOut: isoTime,
        sessionId: id,
      };
      const payload = {
        mutationName: mutationName,
        url: url,
        data: data,
      };
      // Post data
      this.$store
        .dispatch("genericUpdateApiCall", payload)
       
    },
  },

  data() {
    return {
      attendanceList: null,
      today: null,
    };
  },
};
</script>

<style></style>
